let deferredInstallPrompt = null;
let initialized = false;
const listeners = new Set();

function notifyListeners() {
  const canPrompt = Boolean(deferredInstallPrompt);
  listeners.forEach((listener) => {
    try {
      listener(canPrompt);
    } catch (err) {
      console.error('Install prompt listener failed', err);
    }
  });
}

function initInstallPromptListeners() {
  if (initialized) return;
  if (typeof window === 'undefined') return;
  initialized = true;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    notifyListeners();
  });

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    notifyListeners();
  });
}

export function subscribeInstallPrompt(listener) {
  if (typeof listener !== 'function') {
    return () => {};
  }
  if (typeof window === 'undefined') {
    return () => {};
  }
  initInstallPromptListeners();
  listeners.add(listener);
  listener(Boolean(deferredInstallPrompt));
  return () => {
    listeners.delete(listener);
  };
}

export async function promptInstall() {
  if (!deferredInstallPrompt) {
    return 'unavailable';
  }

  try {
    deferredInstallPrompt.prompt();
    const choiceResult = await deferredInstallPrompt.userChoice;
    const outcome =
      choiceResult && (choiceResult.outcome === 'accepted' || choiceResult.outcome === 'dismissed')
        ? choiceResult.outcome
        : 'dismissed';
    return outcome;
  } catch (err) {
    console.error('Install prompt failed', err);
    return 'unavailable';
  } finally {
    deferredInstallPrompt = null;
    notifyListeners();
  }
}

if (typeof window !== 'undefined') {
  initInstallPromptListeners();
}
